import { render, staticRenderFns } from "./AboutMePop.vue?vue&type=template&id=4653b330"
import script from "./AboutMePop.vue?vue&type=script&lang=js"
export * from "./AboutMePop.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports